// extracted by mini-css-extract-plugin
export default {"wrapper":"M8RgE0GGqms_n1qfSEwB"};